import { NavHorizontal, NavItem } from "@flixbus/honeycomb-react";
import cx from "classnames";
import * as React from "react";
import * as css from "./HorizontalNavigation.scss";

export type HorizontalNavigationProps = {
  displayedTab: string;
  onTabClicked: (clickedTab: string) => void;
  labels: Array<{ text: string; key: string }>;
  blockDisplay?: boolean;
};

const HorizontalNavigation: React.FC<HorizontalNavigationProps> = ({
  displayedTab,
  onTabClicked,
  labels,
  blockDisplay,
}) => {
  return (
    <NavHorizontal
      extraClasses={cx(blockDisplay ? css.block : "", css.nav)}
      aria-label={`switch between ${labels.map((label) => label.text)}`}
    >
      {labels.map((label) => {
        return (
          <NavItem
            key={label.key}
            Elem={displayedTab === label.key ? "span" : "button"}
            active={displayedTab === label.key}
            onClick={() => onTabClicked(label.key)}
          >
            {label.text}
          </NavItem>
        );
      })}
    </NavHorizontal>
  );
};

export default HorizontalNavigation;
